import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, mergeProps as _mergeProps, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/plate_error.png'
import _imports_1 from '@/assets/images/pantry_virtual_check.png'


const _hoisted_1 = {
  key: 0,
  class: "pantry-virtual-list-item-plate-empty-graph"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "pantry-virtual-list-item-plate-empty-text-area" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-virtual-list-item-plate-empty-text" }, "未登録")
], -1)
const _hoisted_3 = { class: "pantry-virtual-list-item-circle-text-view" }
const _hoisted_4 = { class: "pantry-virtual-list-item-circle-text" }
const _hoisted_5 = { class: "pantry-virtual-list-item-plate-error-view" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-virtual-list-item-plate-error-icon",
  src: _imports_0
}, null, -1)
const _hoisted_7 = { class: "pantry-virtual-list-item-check-area" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-virtual-list-item-check-icon",
  src: _imports_1
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    ref: "item",
    class: "pantry-virtual-list-item",
    style: _ctx.styleItem
  }, [
    (_ctx.isPlateEmpty())
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", {
            class: "pantry-virtual-list-item-plate-empty",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickCheck(...args)))
          }, [
            _hoisted_2
          ])
        ]))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          class: "pantry-virtual-list-item-circle-graph",
          style: { 'background-image': _ctx.getBackgroundImage() },
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickCheck(...args)))
        }, [
          _withDirectives(_createVNode("div", _mergeProps(_ctx.loadError, {
            class: "pantry-virtual-list-item-circle",
            style: _ctx.styleCircleItem
          }), [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.getName()), 1)
            ])
          ], 16), [
            [_vShow, !_ctx.isShowImage()]
          ]),
          _withDirectives(_createVNode("img", _mergeProps(_ctx.loadError, {
            class: "pantry-virtual-list-item-image",
            src: _ctx.getImage(),
            onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
          }), null, 16, ["src"]), [
            [_vShow, _ctx.isShowImage()]
          ]),
          _withDirectives(_createVNode("div", _hoisted_5, [
            _hoisted_6
          ], 512), [
            [_vShow, _ctx.isShowPlateError()]
          ]),
          _withDirectives(_createVNode("div", _hoisted_7, [
            _hoisted_8
          ], 512), [
            [_vShow, _ctx.isShowCheck()]
          ])
        ], 4))
  ], 4))
}